<template>
  <div class="screen-4">
    <div class="inner">
      <div class="top">一村一品</div>
      <div
        class="middle"
      >“一村一品”是永辉超市2019年的创新项目，旨在深入原始的乡村田野，挖掘最特色的优质农产品、最地道的传统美食，帮助农村将大地的馈赠和传承的饮食文化带给更多消费者。</div>
      <div class="bottom">
        <el-carousel
          indicator-position="none"
          height="250px"
          type="card"
          autoplay
          :interval="2000"
          arrow="never"
          ref="carousel"
        >
          <MyCarouselItem
            v-for="(item, index) in list.slice(0, 5)"
            :key="index"
            style="width: 500px"
            @click="e => onClick(e, item)"
          >
            <div class="card">
              <div class="image">
                <img
                  :src="util.getImageUrl(util.getHead(util.string2Array(item.images)), '250x250')"
                />
              </div>
              <div class="intro">
                <div class="title">{{item.name}}</div>
                <div class="content">{{item.features}}</div>
              </div>
            </div>
          </MyCarouselItem>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import Screen from "./Screen";
import MyCarouselItem from "@/components/index/MyCarouselItem";

export default {
  name: "Screen4",
  extends: Screen,
  components: {
    MyCarouselItem
  },
  data() {
    return {
      id: 4,
      list: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    bounceInUp() {
      this.util.animateCSS(".screen-3 .inner", "slideInUp slow");
    },
    bounceOutUp() {
      this.util.animateCSS(".screen-3 .inner", "slideOutUp slow");
    },
    async init() {
      const response = await this.ajax.doPost({
        packageName: "index",
        className: "index",
        methodName: "index",
        params: {}
      });

      this.list = response.oneVillageOneProductList;
    },

    onClick(e, item) {
      if (e) {
        this.goto("/ovop/detail/" + item.id, true);
      }
    }
  }
};
</script>

<style lang="scss">
.screen-4 {
  .inner {
    width: 1200px;
    z-index: 3;
    .top {
      text-align: center;
      font-size: 56px;
      font-family: "FZQKBYSJW";
      font-weight: normal;
      color: rgba(255, 255, 255, 1);
    }

    .middle {
      margin-top: 50px;
      margin-bottom: 100px;
      text-align: center;
      font-size: 24px;
      font-weight: 200;
      color: rgba(255, 255, 255, 1);
      line-height: 42px;
    }

    .bottom {
      width: 580px;
      margin: 0 auto;
      .card {
        width: 500px;
        height: 250px;
        background: linear-gradient(
          90deg,
          rgba(98, 98, 98, 1) 0%,
          rgba(16, 16, 16, 1) 100%
        );
        cursor: pointer;

        .image {
          width: 250px;
          height: 250px;

          display: inline-block;
          vertical-align: top;
          opacity: 0.9;
          // filter: alpha(opacity=60);

          background: #f6f6f6;
        }

        .intro {
          width: 250px;
          height: 250px;

          display: inline-block;

          vertical-align: top;
          // opacity: 0.6;

          // opacity: 0.6;
          // filter: alpha(opacity=10);
          position: absolute;

          background-image: url(~/images/一村一品底纹.png);

          .title {
            font-size: 20px;
            font-family: "FZQKBYSJW";
            font-weight: normal;
            color: rgba(255, 255, 255, 1);
            line-height: 22px;

            margin: 30px 0 20px 20px;
            z-index: 2;
          }

          .content {
            font-size: 12px;
            font-weight: 200;
            color: rgba(255, 255, 255, 1);
            line-height: 20px;
            margin: 0 20px 0 20px;
            word-break: break-all;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 6;
            overflow: hidden;
            text-overflow: ellipsis;
            z-index: 2;
          }

          image {
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0.9;
            z-index: 1;
          }
        }
      }
    }
  }
}
</style>